import { render, staticRenderFns } from "./RipBeth.vue?vue&type=template&id=2368e0ba&"
import script from "./RipBeth.vue?vue&type=script&lang=ts&"
export * from "./RipBeth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports